<template>
<div class="grid grid-cols-1 md:grid-cols-2">
    <section class="border border-gray-800 p-3">

        <div class="flex">
            <label>Add video file</label>
            <span v-if="errors().file" class="errormessage">{{ errors().file }}</span>
        </div>
        <div class="upload-box">
            <span>
                <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('video_feature_video')">Upload from media library</a>
            </span>
            <span>{{ videoFileName() }}</span>
        </div>

    </section>

</div>
<section class="border border-gray-800 p-3">
    <div class="block text-center">
        <button v-if="!form.processing" class="btn btn-gradient" @click="saveFile"><i class="save"></i></button>
        <button v-else class="btn btn-gradient"><Spinner/></button>
    </div>
</section>

</template>

<script>
import Spinner from '@/UI/Spinner';

export default {
    components: {
        Spinner,
    },
    props: {
      form: Object,
      saveFile: Function,
      changeUploadBoxState: Function,
    },
    methods: {
        errors(){
            return this.$page.props.errors;
        },
        videoFileName(){
            if(this.form.feature_video_files.languages[this.form.current_language].from_media_library_id)
            {
                return this.form.feature_video_files.languages[this.form.current_language].loaded_file_path
            } else {
                return this.form.feature_video_files.languages[this.form.current_language].file &&
                this.form.feature_video_files.languages[this.form.current_language].file.name;
            }
        }
    }
}
</script>
